import React from "react";
import classNames from "classnames";

type OptionObjectProp = {
  text: string;
  value: string;
  selected: boolean;
};

type CapsuleSelectProps = {
  onSelect: (value: string, type: string) => void;
  options: OptionObjectProp[];
  type: string;
  dataTestId: string;
};

const CapsuleSelect: React.FC<CapsuleSelectProps> = ({ onSelect = () => {}, options, type, dataTestId }) => {
  const handleClickTab = (value: string) => {
    onSelect(value, type);
  };

  const optionInputClass = (selected: boolean, index: number, numOfOptions: number) => {
    const isLastOption = index === numOfOptions - 1;
    return classNames("border border-black text-center py-4 hover:bg-wine100 flex-1", {
      "bg-wine100": selected,
      "rounded-l-full": index === 0,
      "rounded-r-full": isLastOption,
    });
  };

  return (
    <div className="flex items-start w-full h-11" data-test-id={dataTestId ?? "capsule-select-component"}>
      {options.map((option, index) => (
        <button
          key={`${option.text}-option`}
          data-test-id={`capsule-select-${type}-${option.value}`}
          className={optionInputClass(option.selected, index, options.length)}
          onClick={() => handleClickTab(option.value)}>
          {option.text}
        </button>
      ))}
    </div>
  );
};

export default CapsuleSelect;
